import TwelveDaysOfCleanup from './TwelveDaysOfCleanup';

export default TwelveDaysOfCleanup;
